const initialState = {
  errors: [],
};

const errorReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_ERRORS":
      return {
        ...state,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default errorReducer;
